import { Divider, Flex } from "@chakra-ui/react";
import FlagBox from "components/LanguageSwitcher/FlagBox";
import type { ModalContextProps } from "contexts/ModalContext";
import { useModal } from "contexts/ModalContext";
import { TOP_MENU_LANG_MODAL_OPEN_EVENT, TOP_MENU_LANG_MODAL_OPEN_EVENT_UA } from "modules/common/trackingConsts";
import { usePathname } from "next/navigation";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import type { HeaderProps } from "../types";

const flagBoxExtraStyles = {
  button: {
    p: 0,
    m: 0,
    minH: "auto",
  },
};

export const HeaderFlagBox = ({
  headerFlagBoxHideForStories,
  testId,
}: Pick<HeaderProps, "headerFlagBoxHideForStories"> & { testId: string }) => {
  const path = usePathname();
  const { openModal } = useModal();
  const { close: closeMobileMenu } = useMobileMenuStore();

  const isDefaultLanguage = path.includes("-default/global/");

  if (isDefaultLanguage || (headerFlagBoxHideForStories.length && headerFlagBoxHideForStories.includes(path)))
    return null;

  const handleLanguageSwitcherClick: ModalContextProps["openModal"] = (modal, size) => {
    closeMobileMenu();
    openModal(modal, size);
  };

  return (
    <Flex mr={{ base: 4, lg: 5 }} alignItems="center" sx={flagBoxExtraStyles} data-testid={testId}>
      <FlagBox
        openModal={handleLanguageSwitcherClick}
        gaEvent={TOP_MENU_LANG_MODAL_OPEN_EVENT}
        uaEvent={TOP_MENU_LANG_MODAL_OPEN_EVENT_UA}
      />
      <Divider
        orientation="vertical"
        ml={{ lg: 4 }}
        h={12}
        borderColor="greyscale.400"
        display={{ base: "none", lg: "initial" }}
      />
    </Flex>
  );
};
